import { getLiveDirectiveNode } from "./getLiveDirectiveNode.js";
import { getLiveDirectiveArgumentValues } from "./getLiveDirectiveArgumentValues.js";
import { isNone } from "./Maybe.js";
export const isLiveQueryOperationDefinitionNode = (input, variables) => {
    const liveDirectiveNode = getLiveDirectiveNode(input);
    if (isNone(liveDirectiveNode)) {
        return false;
    }
    return getLiveDirectiveArgumentValues(liveDirectiveNode, variables).isLive;
};
